import { CreditCardImage } from "@lending/components/CreditCardImage/CreditCardImage";
import { getCreditCardNetwork } from "@lending/utils/getCreditCardNetwork";
import { BulletPoint } from "./BulletPoint/BulletPoint";
import styles from "./CreditCardPromo.module.css";
import type { CreditCardProduct } from "@lending/types";

interface CreditCardPromoProps {
  product: CreditCardProduct;
}

export default function CreditCardPromo({ product }: CreditCardPromoProps) {
  return (
    <div className={styles.creditCardPromoContainer}>
      <div className={styles.creditCardPromo}>
        <div className={styles.header}>
          <div className={styles.titleSection}>
            <span className={styles.title}>{product.name}</span>
            <a
              href={product.more_details_link}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.infoLink}
            >
              {product.more_details_copy}
            </a>
          </div>
          <div className={styles.cardImage}>
            <CreditCardImage network={getCreditCardNetwork(product.card_network)} />
          </div>
        </div>
        <hr className={styles.divider} />
        <div className={styles.bulletPoints}>
          {product.details.map((detail) => (
            <BulletPoint key={detail} text={detail} />
          ))}
        </div>
      </div>
    </div>
  );
}
